<template>
  <div class="question-content">
    <div
      v-if="typeof question.content === 'object'"
      style="padding: 10px;padding-right: 20px;"
    >
      <template v-for="(value, key) in question.content">
        <!-- 图片 -->
        <a
          v-if="key==='picture'"
          :key="key"
          style="cursor: pointer;"
          @click="picturePreview(value)"
        >
          <img
            :src="value + '?x-oss-process=image/resize,h_60'"
            style="height: 60px;"
          >
        </a>

        <!-- 单词 -->
        <template v-if="key==='word'">
          <b :key="key">{{ value }}</b>
        </template>

        <!-- 音频 -->
        <audio-player
          v-if="key==='audio'"
          :key="key"
          :url="value"
        />

        <a
          v-if="key==='egs'"
          :key="key"
        >
          <template v-for="(item, index) in value">
            <a
              v-if="item.picture"
              :key="'picture' + index"
              style="cursor: pointer;"
              @click="picturePreview(item.picture)"
            >
              <img
                :src="item.picture+'?x-oss-process=image/resize,h_60'"
                style="height: 60px;"
              >
            </a>

            <audio-player
              v-if="item.audio"
              :key="'audio' + index"
              :url="item.audio"
            />

            <b :key="'text' + index">{{ item.word || item.say }}</b> &nbsp;&nbsp;
          </template>
        </a>
      </template>
    </div>

    <div style="padding-left: 10px;">
      <p
        style="margin-top: 5px;margin-bottom: 0px"
        v-html="formatText(question.notice)"
      />
      <p
        style="margin-top: 5px;margin-bottom: 0px"
        v-html="formatText(question.title)"
      />
      <template v-if="question.type==='5101'">
        <p
          style="margin-top: 5px;margin-bottom: 0px; word-break:break-word;"
        >
          短文:{{ question.content.article }}
        </p>
        <p
          style="margin-top: 5px;margin-bottom: 0px; word-break:break-word;"
        >
          问题:{{ question.content.ask }}
        </p>
      </template>

      <div style="margin-top: 5px;margin-bottom: 5px;">
        <template v-for="(item, index) in question.section">
          <span :key="'answer' + index">{{ String.fromCharCode(index + 65) }}、</span>

          <template
            v-if="['1101','1102','1103','1104','1105','1106','1107','1108'].includes(question.type)"
          >
            <a
              :key="index"
              style="cursor: pointer;"
              @click="picturePreview(item)"
            >
              <img
                :src="item+'?x-oss-process=image/resize,h_60'"
                style="height: 60px;"
              >
            </a>
          </template>

          <template
            v-else-if="['1201','1202','1203','1204','1205','1206','1401','1402','1403','1404','1405','1406','5101','8601','8602','8604','1208','8506'].includes(question.type)"
          >
            <p
              :key="index"
              style="display:inline; word-break:break-word;"
            >
              {{ item }}
            </p>
          </template>

          <template v-else-if="['1207','1301','1501','1502'].includes(question.type)">
            <template v-if="item.text">
              <b :key="'text' + index">{{ item.text }}</b>
            </template>
            <a
              v-if="item.picture"
              :key="'picture' + index"
              style="cursor: pointer;"
              @click="picturePreview(item.picture)"
            >
              <img
                :src="item.picture+'?x-oss-process=image/resize,h_60'"
                style="height: 60px;"
              >
            </a>

            <audio-player
              v-if="question.type == 1502"
              :key="'audio' + index"
              :url="item"
            />

            <audio-player
              v-if="item.audio"
              :key="'audio' + index"
              :url="item.audio"
            />
          </template>&nbsp;
        </template>
      </div>
    </div>

    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="dialogPictureVisible"
      append-to-body
      custom-class="perview"
    >
      <img
        width="100%"
        :src="dialogPictureUrl"
        alt
      >
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
.question-content {
  display: flex;
  .perview {
    z-index: 4096;
  }
}
</style>


<script>
const debug = require('debug')('ccs:component:question-content');
import audioPlayer from './audio_player';
import { findIndex, pick } from 'lodash';

export default {
	components: {
		audioPlayer
	},
	props: {
		question: [Object]
	},
	data() {
		return {
			// 控制属性
			dialogPictureVisible: false,
			dialogPictureUrl: null,
			selectQuestionDialogVisible: false
		};
	},
	methods: {
		picturePreview(url) {
			debug('[picturePreview] url: %s', url);
			this.dialogPictureUrl = url;
			this.dialogPictureVisible = true;
		},

		formatText(tit) {
			if (tit) {
				return tit.replace(/\\/g, '');
			}
			return '';
		},
		getSectionType(t) {
			if (!isNaN(t)) {
				return parseInt(t / 100);
			}
			return '';
		}
	}
};
</script>
